import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { SessionTimeoutService } from './session-timeout.service';
import { Subscription } from 'rxjs';
import { LocalizationService } from 'src/core/utilitites/localization.service';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'app-session-timeout',
    templateUrl: './session-timeout.component.html',
    styleUrls: ['./session-timeout.component.scss'],
    standalone: false
})
export class SessionTimeoutComponent implements OnInit, OnDestroy, OnChanges {
  element: ElementRef;
  @Input() message: string;
  @Output() extendClicked: EventEmitter<MouseEvent> = new EventEmitter();

  constructor(el: ElementRef, private sessionTimeoutService: SessionTimeoutService, private localizeService: LocalizationService,) {
    this.element = el;
  }
  ngOnChanges(changes: SimpleChanges): void {

  }

  ngOnInit() {
    this.sessionTimeoutService.getSessionAlertStatus().pipe((tap((isVisible) => {
      (this.element.nativeElement as HTMLElement).style.display = (isVisible) ? 'block' : 'none';
    }))).subscribe((isVisible: boolean) => {

    });
  }

  close() {
    this.extendClicked.emit({} as any);
  }
  btnClick(eve) {
    this.extendClicked.emit(eve);
  }
  ngOnDestroy() {
  }
  translate(key: string): any {
    const text = this.localizeService.generateLocalizedStr(key, null, 'html');
    const extendText = this.localizeService.generateLocalizedStr("label.gb.extend_link");
    return text.replace('{{0}}', this.message).replace('{{1}}', extendText)
  }

}
